import { StoreAction } from '../../models/rootState.model';
import { SessionState } from '../../models/session.models';
import { SESSION_ACTION_TYPES } from '../actions/session.actions';

const INITAL_STATE: SessionState = {
    started: false,
    starting: false,
    id: ''
}

export function SessionReducer(
    state = INITAL_STATE,
    action: StoreAction
): SessionState {

    switch (action.type) {
        case SESSION_ACTION_TYPES.INIT: {
            return {
                ...state,
                starting: true
            }
        }

        case SESSION_ACTION_TYPES.STARTED: {
            return {
                ...state,
                ...action.payload,
                started: true,
                starting: false,

            }
        }

        default: { return state}
    }

};